import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import { LANG_DISPLAY_KEY } from '../consts/language';
import { DateTime, Timestamp } from '../interfaces/index.types';

dayjs.extend(localeData);
dayjs.extend(weekday);

function formatHourMonthDayYear(timestamp: Timestamp): DateTime {
  const seconds = timestamp?.seconds || dayjs().unix();

  const date = dayjs.unix(seconds);
  const lang = localStorage.getItem(LANG_DISPLAY_KEY) || 'ja';
  const japaneseWeekday = date.localeData().weekdays(date);
  const formattedJapaneseDate = date.format('YYYY年MM月DD日') + `（${japaneseWeekday}）`;
  dayjs.locale(lang);

  let formattedDate;

  if (lang === 'ja') {
    formattedDate = date.format('YYYY年MM月DD日');
  } else {
    formattedDate = date.format('DD/MM/YYYY');
  }

  return {
    time: date.format('HH:mm'),
    date: formattedDate,
    slashDate: date.format('YYYY/MM/DD'),
    fullDateTime: date.format('YYYY/MM/DD HH:mm'),
    japaneseDate: formattedJapaneseDate,
  };
}

const getStartOfDay = (date: Date) => {
  return dayjs(date).startOf('day').toDate();
};

const getEndOfDay = (date: Date) => {
  return dayjs(date).endOf('day').toDate();
};

const getDayOfWeek = () => {
  const nowTokyo = dayjs().tz('Asia/Tokyo');

  const currentDay = nowTokyo.format('ddd').toUpperCase();
  return currentDay;
};

const getTime = (timestamp: Timestamp | number): string => {
  const seconds = typeof timestamp === 'number' ? timestamp : timestamp?.seconds || dayjs().unix();
  const date = dayjs.unix(seconds);
  return date.format('HH:mm');
};

export { formatHourMonthDayYear, getDayOfWeek, getEndOfDay, getStartOfDay, getTime };

